export const examsTests = [
    {
      title: "CI",
      name: "Intermediate Control",
      description: "Good for a revision of Chapters 1 and 2. The questions are based on the course material and previous CIs.",
      exam_link: "https://drive.google.com/file/d/1VkBfNiEVW9sX8_fc5jj408s4-ghlibtN/view?usp=sharing",
    },
    {
      title: "CF",
      name: "Final Control",
      description: "Good for a revision of the last three chapters. The questions taken from previous CFs and In-class quizes.",
      exam_link: "https://drive.google.com/file/d/1VkBfNiEVW9sX8_fc5jj408s4-ghlibtN/view?usp=sharing",
    },
    {
      title: "CM",
      name: "Mixed Control",
      description: "Good for a general revision (includes all the program). It's a combination of CI and CF questions.",
      exam_link: "https://drive.google.com/file/d/1VkBfNiEVW9sX8_fc5jj408s4-ghlibtN/view?usp=sharing",
    },
    {
      title: "CP",
      name: "Personalized Control",
      description: "Good for a personalized revision. You can choose the chapters you want to be tested on before starting.",
      exam_link: "https://drive.google.com/file/d/1VkBfNiEVW9sX8_fc5jj408s4-ghlibtN/view?usp=sharing",
    }
];